<div class="bg-neutral-7 survey-bar">
    <div class="survey" *ngIf="feedbackState === null">
        <p class="color-white text-350 weight-bold">{{redesignSurveyContent.defaultState}}</p>
        <div class="buttons">
            <axs-button-icon axs-size="small" axs-theme="standard" (click)="onThumbUp()">
                <axs-icon slot="icon" axs-type="thumbUp"></axs-icon>
            </axs-button-icon>
            <axs-button-icon axs-size="small" axs-theme="standard" (click)="onThumbDown()">
                <axs-icon slot="icon" axs-type="thumbDown"></axs-icon>
            </axs-button-icon>
        </div>
    </div>
    <div class="survey" *ngIf="feedbackState === 'positive'">
        <axs-button-icon axs-size="small" axs-theme="inverse">
            <axs-icon slot="icon" axs-type="thumbUp"></axs-icon>
        </axs-button-icon>
        <p class="text-350 color-white"><span
                [innerHTML]="redesignSurveyContent.positiveState"></span>{{constants.SPACE}}<button type="button"
                (click)="openSurvey()"
                class="link-button color-bright-yellow-5">{{redesignSurveyContent.positiveButton}}</button></p>
    </div>
    <div class="survey" *ngIf="feedbackState === 'negative'">
        <axs-button-icon axs-size="small" axs-theme="inverse">
            <axs-icon slot="icon" axs-type="thumbDown"></axs-icon>
        </axs-button-icon>
        <p class="color-white text-350"><span
                [innerHTML]="redesignSurveyContent.negativeState"></span>{{constants.SPACE}}<button type="button"
                (click)="openSurvey()"
                class="link-button color-bright-yellow-5">{{redesignSurveyContent.negativeButton}}</button></p>
    </div>
</div>